import { useTheme } from 'styled-components'

import type { DefaultProps } from './DefaultProps'
import { Wrapper } from './Wrapper'

export const HeaderIconUnauthenticated = ({ title, ...rest }: DefaultProps) => {
	const theme = useTheme() as any

	return (
		<Wrapper {...rest}>
			<svg viewBox='0 0 512 512' fill='none' xmlns='http://www.w3.org/2000/svg'>
				<g clipPath='url(#clip0_26:627)'>
					<path
						d='M61.5272 48.241C-26.4278 101.19 -29.9048 398.129 115.853 276.422C185.96 217.882 195.764 299.947 242.004 257.726C255.204 245.673 266.136 218.85 284.867 224.426C359.308 246.588 243.791 326.002 220.551 364.371C182.54 427.125 247.115 495.309 316.815 484.29C358.284 477.734 373.872 433.977 433.831 444.643C475.659 452.084 522.291 419.499 509.997 379.889C491.908 321.608 424.046 277.776 430.546 212.038C435.775 159.155 401.188 79.403 360.234 72.623C295.224 61.86 223.031 195.047 186.004 94.143C171.947 55.837 128.12 95.48 113.516 76.293C98.5662 56.648 86.5622 33.17 61.5272 48.241V48.241Z'
						fill='url(#paint0_linear_26:627)'
					/>
					<path
						opacity='0.1'
						d='M434.834 90.08H93.974C82.934 90.08 73.974 99.03 73.974 110.08V322.837C55.103 337.418 42.938 360.257 42.938 385.95C42.938 429.984 78.635 465.681 122.669 465.681C146.442 465.681 167.772 455.264 182.38 438.76H434.834C445.874 438.76 454.834 429.81 454.834 418.76V110.08C454.834 99.03 445.874 90.08 434.834 90.08V90.08Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M454.834 86.08V394.76C454.834 405.81 445.874 414.76 434.834 414.76H93.9741C82.9341 414.76 73.9741 405.81 73.9741 394.76V86.08C73.9741 75.03 82.9341 66.08 93.9741 66.08H434.834C445.874 66.08 454.834 75.03 454.834 86.08V86.08Z'
						fill={theme.color.headerIconBackground}
					/>
					<path
						d='M421.051 386.737H109.756C106.995 386.737 104.756 384.498 104.756 381.737V147.923C104.756 145.162 106.995 142.923 109.756 142.923H421.051C423.812 142.923 426.051 145.162 426.051 147.923V381.737C426.051 384.499 423.813 386.737 421.051 386.737Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
					<path
						d='M454.833 118.991V86.079C454.833 75.033 445.879 66.079 434.833 66.079H93.9751C82.9291 66.079 73.9751 75.033 73.9751 86.079V118.991H454.833Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
					<path
						d='M109.756 99.965C112.518 99.965 114.756 97.7265 114.756 94.965C114.756 92.2036 112.518 89.965 109.756 89.965C106.995 89.965 104.756 92.2036 104.756 94.965C104.756 97.7265 106.995 99.965 109.756 99.965Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M126.669 99.965C129.431 99.965 131.669 97.7265 131.669 94.965C131.669 92.2036 129.431 89.965 126.669 89.965C123.908 89.965 121.669 92.2036 121.669 94.965C121.669 97.7265 123.908 99.965 126.669 99.965Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M143.583 99.965C146.344 99.965 148.583 97.7265 148.583 94.965C148.583 92.2036 146.344 89.965 143.583 89.965C140.821 89.965 138.583 92.2036 138.583 94.965C138.583 97.7265 140.821 99.965 143.583 99.965Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M419.052 99.965H172.059C169.298 99.965 167.059 97.726 167.059 94.965C167.059 92.204 169.298 89.965 172.059 89.965H419.052C421.813 89.965 424.052 92.204 424.052 94.965C424.052 97.726 421.814 99.965 419.052 99.965Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M352.136 250.195H256.078C252.162 250.195 248.988 247.021 248.988 243.105V219.027C248.988 215.111 252.162 211.937 256.078 211.937H352.136C356.052 211.937 359.226 215.111 359.226 219.027V243.105C359.226 247.021 356.052 250.195 352.136 250.195Z'
						fill={theme.color.headerIconBackground}
					/>
					<path
						d='M269.734 236.974C272.997 236.974 275.642 234.329 275.642 231.066C275.642 227.803 272.997 225.158 269.734 225.158C266.471 225.158 263.826 227.803 263.826 231.066C263.826 234.329 266.471 236.974 269.734 236.974Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M292.29 236.974C295.553 236.974 298.198 234.329 298.198 231.066C298.198 227.803 295.553 225.158 292.29 225.158C289.027 225.158 286.382 227.803 286.382 231.066C286.382 234.329 289.027 236.974 292.29 236.974Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M314.845 236.974C318.108 236.974 320.753 234.329 320.753 231.066C320.753 227.803 318.108 225.158 314.845 225.158C311.582 225.158 308.937 227.803 308.937 231.066C308.937 234.329 311.582 236.974 314.845 236.974Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M337.4 236.974C340.663 236.974 343.308 234.329 343.308 231.066C343.308 227.803 340.663 225.158 337.4 225.158C334.137 225.158 331.492 227.803 331.492 231.066C331.492 234.329 334.137 236.974 337.4 236.974Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M352.136 303.895H256.078C252.162 303.895 248.988 300.721 248.988 296.805V272.727C248.988 268.811 252.162 265.637 256.078 265.637H352.136C356.052 265.637 359.226 268.811 359.226 272.727V296.805C359.226 300.721 356.052 303.895 352.136 303.895Z'
						fill={theme.color.headerIconBackground}
					/>
					<path
						d='M269.734 290.674C272.997 290.674 275.642 288.029 275.642 284.766C275.642 281.503 272.997 278.858 269.734 278.858C266.471 278.858 263.826 281.503 263.826 284.766C263.826 288.029 266.471 290.674 269.734 290.674Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M292.29 290.674C295.553 290.674 298.198 288.029 298.198 284.766C298.198 281.503 295.553 278.858 292.29 278.858C289.027 278.858 286.382 281.503 286.382 284.766C286.382 288.029 289.027 290.674 292.29 290.674Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M314.845 290.674C318.108 290.674 320.753 288.029 320.753 284.766C320.753 281.503 318.108 278.858 314.845 278.858C311.583 278.858 308.938 281.503 308.938 284.766C308.938 288.029 311.583 290.674 314.845 290.674Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M337.4 290.674C340.663 290.674 343.308 288.029 343.308 284.766C343.308 281.503 340.663 278.858 337.4 278.858C334.137 278.858 331.492 281.503 331.492 284.766C331.492 288.029 334.137 290.674 337.4 290.674Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M214.947 259.723C211.855 259.723 209.348 257.216 209.348 254.124V232.273C209.348 226.061 204.294 221.007 198.082 221.007C191.87 221.007 186.816 226.061 186.816 232.273V236.206C186.816 239.298 184.309 241.805 181.217 241.805C178.125 241.805 175.618 239.298 175.618 236.206V232.273C175.618 219.886 185.696 209.809 198.083 209.809C210.47 209.809 220.547 219.887 220.547 232.273V254.124C220.546 257.216 218.039 259.723 214.947 259.723V259.723Z'
						fill={theme.color.headerIconBackground}
					/>
					<path
						d='M215.383 306.023H180.78C174.595 306.023 169.581 301.009 169.581 294.824V265.212C169.581 259.027 174.595 254.013 180.78 254.013H215.383C221.568 254.013 226.582 259.027 226.582 265.212V294.824C226.581 301.01 221.568 306.023 215.383 306.023Z'
						fill={theme.color.headerIconBackground}
					/>
					<path
						d='M198.081 292.826C194.594 292.826 191.768 289.999 191.768 286.513V280.38C191.768 276.893 194.595 274.067 198.081 274.067C201.568 274.067 204.394 276.894 204.394 280.38V286.513C204.395 289.999 201.568 292.826 198.081 292.826Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
					<path
						d='M122.669 441.681C166.703 441.681 202.4 405.984 202.4 361.95C202.4 317.916 166.703 282.219 122.669 282.219C78.6348 282.219 42.938 317.916 42.938 361.95C42.938 405.984 78.6348 441.681 122.669 441.681Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
					<path
						d='M122.669 426.4C158.264 426.4 187.119 397.545 187.119 361.95C187.119 326.355 158.264 297.5 122.669 297.5C87.0745 297.5 58.2192 326.355 58.2192 361.95C58.2192 397.545 87.0745 426.4 122.669 426.4Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
					<path
						d='M170.673 416.142V425.612C157.313 435.702 140.693 441.682 122.673 441.682C104.653 441.682 88.0229 435.702 74.6729 425.622V416.142C74.6729 399.232 88.3829 385.522 105.293 385.522H111.393V366.132H133.943V385.522H140.043C156.963 385.521 170.673 399.231 170.673 416.142Z'
						fill={theme.color.headerIconBackground}
					/>
					<path
						d='M122.669 381.73C104.91 381.73 90.5137 367.334 90.5137 349.575V341.128C90.5137 323.369 104.91 308.973 122.669 308.973C140.428 308.973 154.824 323.369 154.824 341.128V349.575C154.824 367.334 140.428 381.73 122.669 381.73V381.73Z'
						fill={theme.color.headerIconBackground}
					/>
					<path
						d='M102.853 414.292V439.202C99.423 438.322 96.083 437.222 92.853 435.912V414.292C92.853 411.532 95.093 409.292 97.853 409.292C99.233 409.292 100.483 409.852 101.383 410.752C102.293 411.662 102.853 412.912 102.853 414.292Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
					<path
						d='M152.483 414.292V435.922C149.253 437.222 145.913 438.322 142.483 439.202V414.292C142.483 411.532 144.723 409.292 147.483 409.292C148.863 409.292 150.123 409.852 151.023 410.752C151.923 411.662 152.483 412.912 152.483 414.292V414.292Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
					<path
						d='M454.83 214.315C452.069 214.315 449.83 216.553 449.83 219.315V394.764C449.83 403.035 443.101 409.764 434.83 409.764H192.573C201.918 396.145 207.4 379.678 207.4 361.95C207.4 315.229 169.39 277.219 122.669 277.219C106.693 277.219 91.738 281.668 78.97 289.386V86.075C78.97 77.804 85.699 71.075 93.97 71.075H190.83C193.591 71.075 195.83 68.837 195.83 66.075C195.83 63.313 193.591 61.075 190.83 61.075H93.97C80.185 61.075 68.97 72.29 68.97 86.075V296.46C50.037 312.012 37.937 335.593 37.937 361.95C37.937 408.671 75.947 446.681 122.668 446.681C147.056 446.681 169.056 436.31 184.529 419.764H434.829C448.614 419.764 459.829 408.549 459.829 394.764V219.315C459.83 216.553 457.591 214.315 454.83 214.315V214.315ZM122.669 436.681C81.462 436.681 47.938 403.157 47.938 361.95C47.938 320.743 81.462 287.219 122.669 287.219C163.876 287.219 197.4 320.743 197.4 361.95C197.4 403.157 163.876 436.681 122.669 436.681Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M434.833 61.079H220.22C217.459 61.079 215.22 63.317 215.22 66.079C215.22 68.841 217.459 71.079 220.22 71.079H434.833C443.104 71.079 449.833 77.808 449.833 86.079V189.921C449.833 192.683 452.072 194.921 454.833 194.921C457.594 194.921 459.833 192.683 459.833 189.921V86.079C459.833 72.294 448.618 61.079 434.833 61.079V61.079Z'
						fill={theme.color.headerIconPrimary}
					/>
					<path
						d='M216.615 470.007C216.155 470.007 215.695 469.944 215.248 469.817C202.138 466.09 201.156 447.28 201.12 446.481C201.019 444.21 202.464 442.156 204.636 441.483L215.136 438.231C216.099 437.932 217.131 437.932 218.094 438.231L228.594 441.483C230.766 442.156 232.211 444.21 232.11 446.481C232.074 447.28 231.092 466.09 217.982 469.817C217.535 469.944 217.075 470.007 216.615 470.007V470.007ZM211.607 449.792C212.304 453.311 213.8 457.773 216.614 459.575C219.426 457.774 220.924 453.314 221.621 449.792L216.614 448.241L211.607 449.792Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
					<path
						d='M485.354 338.218C484.894 338.218 484.434 338.155 483.987 338.028C470.876 334.301 469.894 315.491 469.859 314.692C469.758 312.421 471.203 310.367 473.375 309.694L483.875 306.442C484.838 306.143 485.87 306.143 486.833 306.442L497.333 309.694C499.505 310.367 500.95 312.421 500.849 314.692C500.813 315.491 499.831 334.301 486.721 338.028C486.274 338.155 485.814 338.218 485.354 338.218V338.218ZM480.347 318.003C481.043 321.522 482.54 325.984 485.354 327.786C488.166 325.985 489.664 321.525 490.361 318.003L485.354 316.452L480.347 318.003Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
					<path
						d='M186.673 479.007C185.393 479.007 184.114 478.519 183.137 477.542L177.673 472.078L172.209 477.542C170.256 479.495 167.091 479.495 165.138 477.542C163.185 475.59 163.185 472.424 165.138 470.472L174.138 461.472C176.091 459.519 179.256 459.519 181.209 461.472L190.209 470.472C192.162 472.424 192.162 475.59 190.209 477.542C189.232 478.519 187.953 479.007 186.673 479.007Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
					<path
						d='M130.669 45.531C129.389 45.531 128.11 45.043 127.133 44.066L121.669 38.602L116.205 44.066C114.252 46.019 111.087 46.019 109.134 44.066C107.181 42.114 107.181 38.948 109.134 36.996L118.134 27.996C120.087 26.043 123.252 26.043 125.205 27.996L134.205 36.996C136.158 38.948 136.158 42.114 134.205 44.066C133.228 45.042 131.949 45.531 130.669 45.531Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
					<path
						d='M48.9382 277.566C47.6582 277.566 46.3792 277.078 45.4022 276.101L39.9382 270.637L34.4742 276.101C32.5212 278.054 29.3562 278.054 27.4032 276.101C25.4502 274.149 25.4502 270.983 27.4032 269.031L36.4032 260.031C38.3562 258.078 41.5212 258.078 43.4742 260.031L52.4742 269.031C54.4272 270.983 54.4272 274.149 52.4742 276.101C51.4972 277.077 50.2172 277.566 48.9382 277.566Z'
						fill={theme.color.headerIconPrimaryAccent}
					/>
				</g>
				<defs>
					<linearGradient
						id='paint0_linear_26:627'
						x1='37.44'
						y1='151.899'
						x2='533.758'
						y2='386.845'
						gradientUnits='userSpaceOnUse'
					>
						<stop stopColor={theme.color.headerIconGradientStart} stopOpacity='0' />
						<stop offset='1' stopColor={theme.color.headerIconGradientStop} />
					</linearGradient>
					<clipPath id='clip0_26:627'>
						<rect width='512' height='512' fill={theme.color.headerIconBackground} />
					</clipPath>
				</defs>
				<title>{title ?? 'Unauthenticated'}</title>
			</svg>
		</Wrapper>
	)
}
